.events-container {
  position: absolute;
  right: 0;
  bottom: 0;
  left: var(--rc-calendar-hour-width);
  pointer-events: none;

  > .events-day {
    position: relative;
    width: calc(100% - var(--rc-calendar-spacing-xs));
    height: 100%;
    border-right: 0;
    pointer-events: none;

    > * {
      pointer-events: auto;
    }
  }

  &.week-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    flex: 1;
  }
}
